import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { concatMap, filter, map, take, combineLatest, Observable, of } from "rxjs";

import { AuthService } from "../auth/auth.service";
import { ProfileQuery } from "../profile/state/profile.query";
import { PermissionsService } from "../auth/permissions.service";
import { RoutesManager } from "../shared/models/routes.interfaces";
import { RoleEnum } from "../core/models/permission-role.enum";

@Injectable({
    providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {

    constructor(
        private authService: AuthService,
        private profileQuery: ProfileQuery,
        private permissionsService: PermissionsService,
    ) { }

    preload(route: Route, load: () => Observable<any>): Observable<any> {
        let isRoleAllowed: Observable<boolean>;
        
        if (route?.path === RoutesManager.companySettings) {
            isRoleAllowed = of(true);
        } else if (route?.path === RoutesManager.ai_agents) {
            // Only preload ai_agents for Admin and Agent roles
            isRoleAllowed = this.permissionsService.selectIsAllowed([
                RoleEnum.Agent, 
                RoleEnum.Admin
            ]);
        } else {
            isRoleAllowed = this.permissionsService.selectIsAllowed([
                RoleEnum.Agent, 
                RoleEnum.Admin, 
                RoleEnum.DsrManager, 
                RoleEnum.DsrAgent, 
                RoleEnum.InventoryManager
            ]);
        }
        
        return combineLatest([
            isRoleAllowed,
            this.authService.isLoggedIn$,
            this.profileQuery.select('verifiedToCompany'),
        ]).pipe(
            map(res => res.every(r => r === true)),
            filter(res => res === true && route.data && route.data['preload']),
            take(1),
            concatMap(() => load())
        );
    }
}